import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;

export default new Vuex.Store({
  state: {
    user: {},
    pricing: localStorage.getItem('pricing') || null,
    token: localStorage.getItem('access_token') || null,
    filters: {
      free: true,
      enterprise: true,
      userPricing: true,
      moneyBack: true
    },
    stats: {},
    currencies: [],
    companies: {},
    ctas:[],
    hash: '',
    popupCounter: 0
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
    },
    setPricing(state, pricing) {
      state.pricing = pricing;
    },
    setCompanies(state, companies) {
      state.companies = companies;
    },
    toggleFree(state) {
      state.filters.free = !state.filters.free;
    },
    toggleEnterprise(state) {
      state.filters.enterprise = !state.filters.enterprise;
    }
    ,
    toggleUserPricing(state) {
      state.filters.userPricing = !state.filters.userPricing;
    },
    toggleMoneyBack(state) {
      state.filters.moneyBack = !state.filters.moneyBack;
    },
    setStats(state, stats) {
      state.stats = stats;
    },
    setCurrencies(state, currencies) {
      state.currencies = currencies;
    },
    setCtas(state, ctas) {
      state.ctas = ctas;
    },
    setHash(state, hash) {
      state.hash = hash;
    },
    incrementPopupCounter(state) {
      state.popupCounter++;
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    loggedIn(state) {
      return state.token !== null;
    },
    pricing(state) {
      return state.pricing;
    },
    companies(state) {
      return state.companies;
    },
    free(state) {
      return state.filters.free;
    },
    enterprise(state) {
      return state.filters.enterprise;
    },
    userPricing(state) {
      return state.filters.userPricing;
    },
    moneyBack(state) {
      return state.filters.moneyBack;
    },
    stats(state) {
      return state.stats;
    },
    currencies(state) {
      return state.currencies;
    },
    ctas(state) {
      return state.ctas;
    },
    hash(state) {
      return state.hash;
    },
    popupCounter(state) {
      return state.popupCounter;
    }
  },
  actions: {
    retrieveUserDetails(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.get('user').then(response => {
            const user = response.data.data;
            context.commit('setUser', user);
            context.commit('setHash', user.hash);
            resolve(response);
          }).catch(error => {
            context.commit('setUser', {});
            context.commit('setHash', '');
            reject(error);
          })
        })
      }
    },
    retrievePricing(context) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('plans/allCombined').then(response => {
          const pricing = response.data.data;
          localStorage.setItem('setPricing', pricing);
          context.commit('setPricing', pricing);
          resolve(pricing);
        }).catch(error => {
          localStorage.removeItem('setPricing');
          context.commit('setPricing');
          reject(error);
        })
      })
    },
    retrievePricingPro(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      return new Promise((resolve, reject) => {
        Vue.axios.get('full/plans/allCombined').then(response => {
          const pricing = response.data.data;
          localStorage.setItem('setPricing', pricing);
          context.commit('setPricing', pricing);
          resolve(pricing);
        }).catch(error => {
          localStorage.removeItem('setPricing');
          context.commit('setPricing');
          reject(error);
        })
      })
    },
    retrieveCompanies(context) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('companies/all').then(response => {
          const companies = response.data.data;
          localStorage.setItem('setCompanies', companies);
          context.commit('setCompanies', companies);
          resolve(companies);
        }).catch(error => {
          localStorage.removeItem('setCompanies');
          context.commit('setCompanies');
          reject(error);
        })
      })
    },
    retrieveCompaniesPro(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      return new Promise((resolve, reject) => {
        Vue.axios.get('full/companies/all').then(response => {
          const companies = response.data.data;
          localStorage.setItem('setCompanies', companies);
          context.commit('setCompanies', companies);
          resolve(companies);
        }).catch(error => {
          localStorage.removeItem('setCompanies');
          context.commit('setCompanies');
          reject(error);
        })
      })
    },
    retrieveStats(context) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('stats').then(response => {
          const stats = response.data.data;
          localStorage.setItem('setStats', stats);
          context.commit('setStats', stats);
          resolve(stats);
        }).catch(error => {
          localStorage.removeItem('setStats');
          context.commit('setStats');
          reject(error);
        })
      })
    },
    retrieveCurrencies(context) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('currencies').then(response => {
          const currencies = response.data.data;
          localStorage.setItem('setCurrencies', currencies);
          context.commit('setCurrencies', currencies);
          resolve(currencies);
        }).catch(error => {
          localStorage.removeItem('setCurrencies');
          context.commit('setCurrencies');
          reject(error);
        })
      })
    },
    retrieveCurrenciesPro(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      return new Promise((resolve, reject) => {
        Vue.axios.get('full/currencies').then(response => {
          const currencies = response.data.data;
          localStorage.setItem('setCurrencies', currencies);
          context.commit('setCurrencies', currencies);
          resolve(currencies);
        }).catch(error => {
          localStorage.removeItem('setCurrencies');
          context.commit('setCurrencies');
          reject(error);
        })
      })
    },
    retrieveCtas(context) {
      return new Promise((resolve, reject) => {
        Vue.axios.get('ctas').then(response => {
          const ctas = response.data.data;
          localStorage.setItem('setCtas', ctas);
          context.commit('setCtas', ctas);
          resolve(ctas);
        }).catch(error => {
          localStorage.removeItem('setCtas');
          context.commit('setCtas');
          reject(error);
        })
      })
    },
    retrieveCtasPro(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      return new Promise((resolve, reject) => {
        Vue.axios.get('full/ctas').then(response => {
          const ctas = response.data.data;
          localStorage.setItem('setCtas', ctas);
          context.commit('setCtas', ctas);
          resolve(ctas);
        }).catch(error => {
          localStorage.removeItem('setCtas');
          context.commit('setCtas');
          reject(error);
        })
      })
    },
    destroyToken(context) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token;
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          Vue.axios.post('logout').then(response => {
            localStorage.removeItem('access_token');
            context.commit('destroyToken');
            resolve(response);
          }).catch(error => {
            localStorage.removeItem('access_token');
            context.commit('destroyToken');
            reject(error);
          })
        })
      }
    },
    retrieveToken(context, credentials) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('login', {
          hash: credentials.hash
        }).then(response => {
          const token = response.data.access_token;
          localStorage.setItem('access_token', token);
          context.commit('retrieveToken', token);
          resolve(response);
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  modules: {
  }
})
